














































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import SaleOrderDetail from "../../../store/entities/sale-order-detail";
import SaleOrder from "../../../store/entities/sale-order";
import Barcode from "../../components/bar-code.vue";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import linecolumns from "./view-sale-order-line-columns";
import packagecolumns from "./view-sale-oder-package-columns";
import SerialInfo from "@/store/entities/serialinfo";
import ProductSerial from "@/views/components/view-serials.vue";
import SaleOrderLineDetail from "../../../store/entities/sales-orders/vw-so-line";
import Tpl from "@/store/entities/tpls/tplForSelect";
import AppConsts from "../../../lib/appconst";
import NoteModal from "../../components/note-modal.vue";
import _ from "lodash";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import SoPickList from "./modal-soLine-product-picklist.vue";

class PageSaleOrderLineRequest extends PageRequest {
  keyword: string;
  soId: number;
  shortedQty: boolean;
}
class PageDeliveryPackageRequest extends PageRequest {
  keyword: string;
  refId: number;
  refTypeCode: string;
}
class PagePickListRequest extends PageRequest {
  keyword: string;
  refId: number;
}
@Component({
  components: {
    "bar-code": Barcode,
    "view-serials": ProductSerial,
    "note-modal": NoteModal,
    "so-line-pick-list": SoPickList,
  },
})
export default class ViewSaleOrder extends mixins(
  ListMixin,
  DateTimeMixin,
  AbpBase
) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  maximumFractionDigits = AppConsts.maximumFractionDigits;
  namespace = "deliveryPackage";
  lineNamespace = "vwSoLine";
  plNamespace = "refPickList";
  pagerequest: PageDeliveryPackageRequest = new PageDeliveryPackageRequest();
  linepagerequest: PageSaleOrderLineRequest = new PageSaleOrderLineRequest();
  plPageRequest: PagePickListRequest = new PagePickListRequest();
  saleOrder: SaleOrderDetail = new SaleOrderDetail();
  soLineList: Array<SaleOrderLineDetail> = [];
  spinShow: boolean = false;
  code: string = "";
  id: number = 0;
  viewSerialModelShow: boolean = false;
  itemSerialForView: SerialInfo = new SerialInfo();
  soTplCode: string = "";
  tpls: Array<Tpl> = new Array<Tpl>();
  cancelNote: string = "";
  noteModalShow: boolean = false;
  canUpdateCommonInfo: boolean = false;
  extensionInfos = [];
  statusTrackings = [];
  invalidCancelSoStatusArr = [
    AppConsts.soStatus.returned,
    AppConsts.soStatus.returning,
    AppConsts.soStatus.delivered,
    AppConsts.soStatus.delivering,
    AppConsts.soStatus.shipped,
    AppConsts.soStatus.canceled,
    AppConsts.soStatus.ship_par,
  ];
  soPickListModalShow: boolean = false;
  editConfirmQtyProductId = 0;
  editConfirmQtySoLineId = 0;
  get store() {
    return this.$store.state.deliveryPackage;
  }
  get lineStore() {
    return this.$store.state.vwSoLine;
  }
  get plStore() {
    return this.$store.state.refPickList;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  cancel() {
    this.$store.state.saleOrder.viewSaleOrder = new SaleOrder();
    this.$emit("input", false);
    this.$root.$router.push({ name: "saleorder" });
  }
  isPacked() {
    return this.totalCount > 0;
  }
  onReceipt() {
    var url2 = `/#/invoice/${this.saleOrder.code}/2`;
    window.open(url2, "_blank");
  }

  onReceiptTransfer() {
    var url = `/#/invoice-transfer/${this.saleOrder.code}`;
    window.open(url, "_blank");
  }

  onShippingLabel(packageNo: string) {
    var url = `/#/shippinglabel/${this.saleOrder.code}/${packageNo}`;
    window.open(url, "_blank");
  }
  validEditingAllocatingQtyStatus() {
    return (
      this.saleOrder.soStatusCode === AppConsts.soStatus.new ||
      this.saleOrder.soStatusCode === AppConsts.soStatus.pa
    );
  }
  validEditingConfirmPackingQtyStatus() {
    return (
      ((this.saleOrder.soStatusCode === AppConsts.soStatus.picking ||
        this.saleOrder.soStatusCode === AppConsts.soStatus.picked_par) &&
        this.hasPermission("Operations.SalesOrders.AdjustConfirmPickingQty")) ||
      (this.saleOrder.soStatusCode === AppConsts.soStatus.packing &&
        this.hasPermission("Operations.SalesOrders.AdjustConfirmPackingQty"))
    );
  }
  hasEditConfirmQtyPermission() {
    return (
      !this.isCanceldSalesOrder() &&
      (this.hasPermission("Operations.SalesOrders.AdjustConfirmPickingQty") ||
        this.hasPermission("Operations.SalesOrders.AdjustConfirmPackingQty"))
    );
  }

  hasEditAllocatingPermission() {
    return (
      !this.isCanceldSalesOrder() &&
      this.hasPermission("Operations.SalesOrders.AdjustAllocatingqty") &&
      this.validEditingAllocatingQtyStatus()
    );
  }
  hasUpdateCommonInfoPermission() {
    return (
      this.isTenant() &&
      !this.isCanceldSalesOrder() &&
      this.hasPermission("Operations.SalesOrders.UpdateCommonInfo") &&
      this.saleOrder.canUpdateCommonInfo
    );
  }
  hasFinishPermission() {
    return (
      this.saleOrder.canFinish &&
      this.hasPermission("Operations.SalesOrders.Finish")
    );
  }
  isCanceldSalesOrder() {
    return this.saleOrder.soStatusCode === AppConsts.soStatus.canceled;
  }

  showEdit(row: any, index: number) {
    if (row.showEdit === false) {
      row.showEdit = true;
    }
  }
  checkEditQty(row: any, index: number) {
    var item = row;
    var editQty = row.allocatingQty;
    if (editQty > row.orderQty) {
      editQty = row.orderQty;
    }
    row.allocatingQty = editQty;
    this.soLineList[index].showEdit = row.showEdit;
    this.soLineList[index].allocatingQty = editQty;
    var lineStoreIndex = _.findIndex(this.lineStore.list, { id: row.id });
    if (!Util.isNull(lineStoreIndex) && lineStoreIndex >= 0) {
      this.lineStore.list[lineStoreIndex].allocatingQty = editQty;
    }
  }

  getDataToSave() {
    var items = this.soLineList.map(function (i) {
      return {
        Sku: i.sku,
        LineNumber: i.id,
        AllocatingQty: i.allocatingQty,
      };
    });
    return {
      soId: this.id,
      items: items,
      note: this.saleOrder.problemNote,
    };
  }
  async saveExceptions() {
    if (Util.isEmpty(this.saleOrder.problemNote)) {
      Util.showErrorMsg(this, "Error.ProblemNoteIsRequired");
      return;
    }
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.AdjustSoAllocatingQty"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          var data = this.getDataToSave();
          await this.$store
            .dispatch({
              type: "saleOrder/adjustAllocatingQty",
              data: data,
            })
            .then((result) => {
              Util.showSuccessMsg(this, "Success.AdjustSoAllocatingQty");
            });
          this.getlinepage();
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  async getTpls() {
    await this.$store
      .dispatch({
        type: "tpl/getListForSelect",
      })
      .then(() => {
        this.tpls = this.$store.state.tpl.tplsForSelect;
      });
  }
  async saveToUpdateCommonInfo() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.UpdateSalesOrderCommonInfo"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          await this.$store
            .dispatch({
              type: "saleOrder/updateSoCommonInfomation",
              data: {
                soId: this.saleOrder.id,
                customerId: this.saleOrder.customerId,
                tplCode: this.soTplCode,
              },
            })
            .then((result) => {
              Util.showSuccessMsg(this, "Success.UpdateSalesOrderCommonInfo");
              this.saleOrder.tplCode = result.tplCode;
              this.saleOrder.invoiceNo = result.invoiceNo;
            });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  canCancelSoStatus() {
    return !this.invalidCancelSoStatusArr.includes(this.saleOrder.soStatusCode);
  }
  canCancelSo() {
    if (
      this.canCancelSoStatus() &&
      this.hasPermission(AppConsts.permissionNames.cancelSalesOrder)
    ) {
      return true;
    }
    return false;
  }
  openCancelNoteModal() {
    this.cancelNote = "";
    this.noteModalShow = true;
  }
  cancelSalesOrder() {
    if (Util.isEmpty(this.cancelNote)) {
      return;
    }
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.CancelSalesOrder"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          await this.$store
            .dispatch({
              type: "saleOrder/cancel",
              data: {
                id: this.saleOrder.id,
                note: this.cancelNote,
              },
            })
            .then(async (esult) => {
              await this.getSalesOrder();
              Util.showSuccessMsg(this, "Success.CancelSalesOrder");
              this.cancelNote = "";
            });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  openSoPickListModal(row) {
    this.editConfirmQtyProductId = row.productId;
    this.editConfirmQtySoLineId = row.id;
    this.soPickListModalShow = true;
  }
  closeSoPickListModal() {
    this.soPickListModalShow = false;
    this.getlinepage();
  }
  async finish() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.FinishSalesOrder"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        await this.$store
          .dispatch({
            type: "saleOrder/finish",
            data: {
              id: this.saleOrder.id,
            },
          })
          .then(async () => {
            Util.showSuccessMsg(this, "Success.FinishSalesOrder");
            await this.getSalesOrder();
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }

  get list() {
    var re = this.$store.state.deliveryPackage.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function (item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });

    return re;
  }
  preGetPage() {
    this.pagerequest.refId = this.saleOrder.id;
    this.pagerequest.refTypeCode = "SO";
  }
  // sale order line
  get lineList() {
    var re = this.lineStore.list;
    var startIndex = (this.lineCurrentPage - 1) * this.linePageSize;
    var index = 0;
    re.forEach(function (item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    this.soLineList = re;
    return this.soLineList;
  }
  get lineLoading() {
    return this.lineStore.loading;
  }
  linePageChange(page: number) {
    this.$store.commit(`${this.lineNamespace}/setCurrentPage`, page);
    this.getlinepage();
  }

  linePagesizeChange(pagesize: number) {
    this.$store.commit(`${this.lineNamespace}/setPageSize`, pagesize);
    this.getlinepage();
  }

  async getlinepage() {
    this.linepagerequest.maxResultCount = this.linePageSize;
    this.linepagerequest.skipCount =
      (this.lineCurrentPage - 1) * this.linePageSize;
    this.linepagerequest.soId = this.saleOrder.id;
    //filters
    await this.$store.dispatch({
      type: `${this.lineNamespace}/getAll`,
      data: this.linepagerequest,
    });
  }

  get linePageSize() {
    return this.lineStore.pageSize;
  }

  get lineTotalCount() {
    return this.lineStore.totalCount;
  }

  get lineCurrentPage() {
    return this.lineStore.currentPage;
  }
  get loading() {
    return this.$store.state.saleOrder.loading;
  }
  //==========PickList
  get plList() {
    var re = this.plStore.list;
    var startIndex = (this.plCurrentPage - 1) * this.plPageSize;
    var index = 0;
    re.forEach(function (item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  get plLoading() {
    return this.plStore.loading;
  }
  plPageChange(page: number) {
    this.$store.commit(`${this.plNamespace}/setCurrentPage`, page);
    this.getplpage();
  }

  plPagesizeChange(pagesize: number) {
    this.$store.commit(`${this.plNamespace}/setPageSize`, pagesize);
    this.getplpage();
  }
  async searchPl() {
    this.plPageChange(1);
  }
  async getplpage() {
    this.plPageRequest.maxResultCount = this.plPageSize;
    this.plPageRequest.skipCount = (this.plCurrentPage - 1) * this.plPageSize;
    this.plPageRequest.refId = this.saleOrder.id;
    //filters
    await this.$store.dispatch({
      type: `${this.plNamespace}/getAll`,
      data: this.plPageRequest,
    });
  }

  get plPageSize() {
    return this.plStore.pageSize;
  }

  get plTotalCount() {
    return this.plStore.totalCount;
  }

  get plCurrentPage() {
    return this.plStore.currentPage;
  }
  //=========================================
  async getSalesOrder() {
    await this.$store
      .dispatch({
        type: "saleOrder/getByCode",
        data: { code: this.code },
      })
      .then(async (result) => {
        this.saleOrder = result;
        this.id = this.saleOrder.id;
        this.code = this.saleOrder.code;
        this.soTplCode = this.saleOrder.tplCode;
        await this.getSalesOrderExtensionInfos();

        this.getpage();
        this.getlinepage();
        if (this.hasUpdateCommonInfoPermission()) {
          this.getTpls();
        }
        await this.getSoStatusTrackings();
      });
  }
  async getSalesOrderExtensionInfos() {
    this.$store.state.saleOrder.loading = true;
    await this.$store
      .dispatch({
        type: "saleOrder/getSoExtensionInfos",
        data: this.saleOrder.id,
      })
      .then((result) => {
        this.extensionInfos = result;
      });
    this.$store.state.saleOrder.loading = false;
  }
  async getSoStatusTrackings() {
    this.$store.state.saleOrder.loading = true;
    await this.$store
      .dispatch({
        type: "saleOrder/getSoStatusTrackings",
        data: this.saleOrder.id,
      })
      .then((result) => {
        this.statusTrackings = result;
      });
    this.$store.state.saleOrder.loading = false;
  }
  async created() {
    this.spinShow = true;
    try {
      this.code = this.$root.$router.currentRoute.params.code;
      await this.getSalesOrder();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
  showSerials(index: number) {
    var rowItem = this.lineList[index];
    this.itemSerialForView.sku = rowItem.sku;
    this.itemSerialForView.productName = rowItem.productName;
    this.itemSerialForView.qty = rowItem.packedQty;
    this.itemSerialForView.serialNoes = rowItem.serials;
    this.viewSerialModelShow = true;
  }
  renderSOInfoContentElements(content: string) {
    var contenHlmlString = "";
    if (!Util.isEmpty(content)) {
      if (content.endsWith("#")) content = content.slice(0, content.length - 1);
      var contentObj = content.split("#");
      if (contentObj == null || contentObj.length <= 0) return "";

      for (var i = 0; i < contentObj.length; i++) {
        contenHlmlString = contenHlmlString.concat(
          "<span>" + contentObj[i] + "</span><br/>"
        );
      }
    }
    return contenHlmlString;
  }
  rowLineClassName(row, index) {
    if (Util.isNull(row.shortQty) || row.shortQty <= 0) return "";
    return "redRowClass";
  }
  lineColumns = linecolumns;
  lineEditConfirmQtyColumns = [
    ...linecolumns,
    {
      title: Util.L("Action"),
      slot: "action",
      align: "center",
      width: 100,
    },
  ];
  packageColumns = packagecolumns;
  extensionInfoColumns = [
    {
      title: Util.L("SoInfoType"),
      width: 250,
      key: "infoTypeName",
    },
    {
      title: Util.L("Content"),
      slot: "content",
    },
    {
      title: Util.L("InputChannelCode"),
      width: 150,
      key: "inputChannelName",
    },
    {
      title: Util.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
  ];
  statusTrackingColumns = [
    {
      title: Util.L("Status"),
      key: "newStatusText",
    },
    {
      title: Util.L("CreatorUserName"),
      width: 250,
      key: "creatorUserName",
    },
    {
      title: Util.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
  ];
  plColumns = [
    {
      title: this.L("Order"),
      width: 60,
      key: "orderNo",
    },
    {
      title: Util.L("Code"),
      width: 200,
      key: "code",
      slot: "pickList",
    },
    {
      title: Util.L("Type"),
      width: 200,
      key: "typeName",
    },
    {
      title: Util.L("Status"),
      width: 150,
      key: "statusName",
    },
    {
      title: Util.L("Employee"),
      width: 150,
      key: "employeeId",
      render: (h: any, params: any) => {
        if (_.isNil(params.row.employeeId) || params.row.employeeId <= 0)
          return;
        return h(
          "span",
          `${params.row.employeeUserName} - ${params.row.employeeName}`
        );
      },
    },
    {
      title: Util.L("StartTime"),
      key: "startTime",
      width: 170,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.startTime)) return;
        return h("span", Util.toViewDateString(params.row.startTime));
      },
    },
    {
      title: Util.L("EndTime"),
      key: "endTime",
      width: 170,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.endTime)) return;
        return h("span", Util.toViewDateString(params.row.endTime));
      },
    },
    {
      title: Util.L("CreationTime"),
      key: "creationTime",
      width: 170,
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
  ];
}
